<template>
  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">
    <div class="popup-cont"
         tabindex="1">
      <h2 class="popup-heading">{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} SIZE</h2>
      <div class="popup-item">
        <h4>Size Name</h4>
        <p>Only you will see this name. It will appear as a choice of selection when you want to add this size
          to a product.</p>
        <input type="text" class="pop-input" placeholder="Size Name" v-model="name" name="Size Name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Size Name')">{{ errors.first('Size Name') }}</span>
      </div>
      <div class="popup-item">
        <h4>Instructions to Customers</h4>
        <p>Describe how this size will effect your customers order.</p>
        <textarea class="pop-textarea"
                  placeholder="Example: Select a size"
                  v-model="instructions" name="Instructions" v-validate="'required'"></textarea>
        <span class="text-danger text-sm" v-show="errors.has('Instructions')">{{ errors.first('Instructions') }}</span>
      </div>
      <div class="popup-item">
        <h4>Size Options</h4>
        <div v-if="sizeOptions.length > 0" class="mod-inputs" v-for="(item,index) in sizeOptions" :key="index">
          <div class="mod-opt-input">
            <vs-input type="text"
                      class="pop-input mod-options"
                      placeholder="Size Option Name"
                      :value="item.name" @input="sizeOptionNameChange(index, $event)"
                      name="option-name" v-validate="'required'" />
          </div>
          <div class="mod-opt-input">
            <vs-input type="number"
                      class="pop-input mod-options"
                      placeholder="Size Price"
                      :value="item.price !== 0 ? item.price : ''" @input="sizeOptionPriceChange(index, $event)"
                      name="option-price" />
            <p>Leave empty if this option is free</p>
          </div>
          <feather-icon class="ml-4 cursor-pointer" @click="deleteSizeOption(index)" icon="XIcon"  />
          <span class="text-danger text-sm"
                v-show="errors.has('option-name')">{{ errors.first('option-name') }}</span>
        </div>

        <div class="mod-button" @click="addSizeOption"><i class="fas fa-plus"></i> Add More</div>
      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" :class="isFormValid ? '' : 'inactive'" @click="submitData">{{ this.data.add === true ? "Add New" : "Update" }} Size</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      sizeId: null,
      name: '',
      instructions: '',
      restaurantId: null,
      items: [],
      size_item : {
        sizeItemId: null,
        name: '',
        price: '0',
        order: 0
      },
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        this.sizeOptions = []
        return
      }
      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { name, id, instructions, restaurant_id, items} = this.data
        this.sizeId = id
        this.name = name
        this.instructions = instructions
        this.restaurantId = restaurant_id
        this.sizeOptions = items
        //this.initValues()
      }
      return true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    sizeOptions: {
      get () {
        return this.$store.state.api.sizeOptions
      },
      set (val) {
        this.$store.dispatch('api/setsizeoptions', val)
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.instructions
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    initValues () {
      if (this.data.id) return
      this.sizeId = null
      this.name = ''
      this.instructions = ''
      this.restaurantId = this.data.restaurantId
    },
    sizeOptionNameChange (index, e) {
      this.$store.dispatch('api/setsizeoptionsitem', { type:'name', index, value: e})
    },
    sizeOptionPriceChange (index, e) {
      this.$store.dispatch('api/setsizeoptionsitem', { type:'price', index, value: e})
    },
    addSizeOption () {
      this.size_item.name = 'Option '.concat(this.sizeOptions.length)
      const item = {
        id: null,
        name: 'Option '.concat(this.sizeOptions.length + 1),
        price: '0',
        order: 0
      }
      this.$store.dispatch('api/setsizeoptionsitem', { type:'add', value: item})
      this.size_item.name = ''
    },

    deleteSizeOption (index) {
      this.$store.dispatch('api/setsizeoptionsitem', { type:'delete', index})
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted option',
        text: 'The selected modifier was successfully deleted'
      })
    },
    submitData () {

      this.$validator.validateAll().then(result => {
        this.$vs.loading()
        if (result) {
          for (let i = 0; i < this.sizeOptions.length; i++) {
            this.$store.dispatch('api/setsizeoptionsitem', { type:'order', index: i, value: i * 10})
          }

          const obj = {
            sizeId: this.sizeId,
            name: this.name,
            instructions: this.instructions,
            restaurantId: this.restaurantId,
            items: this.sizeOptions
          }
          this.$store.dispatch('api/addSize', obj).then((response) => {
            this.$vs.notify({
              title: 'Success',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$emit('closeSidebar')
            this.initValues()
            this.$vs.loading.close()
          }).catch(err => {
            console.error(err)
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$vs.loading.close()
          })

        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
